var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreyChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.8242 6.41992C5.62706 6.41992 5.42994 6.34789 5.27964 6.20414L0.549875 1.67824C0.249 1.39034 0.249 0.923549 0.549875 0.635762C0.850628 0.347975 1.33835 0.347975 1.63925 0.635762L5.8242 4.64053L10.0092 0.635902C10.3101 0.348115 10.7977 0.348115 11.0985 0.635902C11.3995 0.923689 11.3995 1.39047 11.0985 1.67838L6.36876 6.20428C6.21839 6.34806 6.02127 6.41992 5.8242 6.41992Z",
    fill: "#AAA6A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyChevronDown);
export default __webpack_public_path__ + "static/media/grey-chevron-down.7da9af6cc6c26b0f5c4d5b2daf27e2a8.svg";
export { ForwardRef as ReactComponent };